import { PeriscopeSource } from '@ui/icons';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Col, Row } from 'antd';
import { PopulationPercentageTag, ReferenceCountTag } from '@ui/tags';
export const PrimaryColumn = ({ label, entry }) => {
    const { name, sonarObjectId, sourceUrl } = entry;
    const { populationPercentage, referenceCount } = entry;
    return (React.createElement("div", null,
        React.createElement(Row, { justify: 'space-between', wrap: false },
            React.createElement(Col, { className: 'label' }, label === null || label === void 0 ? void 0 : label.trim()),
            React.createElement(Col, { className: 'source-link' },
                React.createElement(PeriscopeSource, { id: `${sonarObjectId}-link`, sonarObjectType: SonarObjectType.SalesforceField, url: sourceUrl }))),
        React.createElement(Row, null,
            React.createElement(ReferenceCountTag, { count: referenceCount }),
            React.createElement(PopulationPercentageTag, { parentName: name, percent: populationPercentage }))));
};
